import React, { FC } from "react"
import ContentSlides from "@components/ContentSlides"
import { GatsbyImage } from "gatsby-plugin-image"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiContentSlides: FC<Queries.StrapiComponentSectionsContentSlides> = ({
    content,
    content_images: contentImages,
    slides
}) => {
    return <ContentSlides
        content={`${parseContentImages(
            content,
            contentImages as unknown as ParseContentImagesProps[]
        )}`}
        images={slides?.map((slide) => {
            return <GatsbyImage
                alt={slide?.image?.alternativeText}
                image={slide?.image?.file?.childImageSharp?.gatsbyImageData}
            />
        })}
    />
}

export default StrapiContentSlides
